import {resolveIdentifier, types} from "mobx-state-tree";
import {Brand, BrandStore} from "./BrandStore";

export const BrandSelectState = types.model('BrandSelectState', {
    brandStore: types.maybeNull(BrandStore),
    selected: types.maybe(types.safeReference(Brand)),
}).volatile((self) => ({
    notifyList: types.str,
})).actions((self) => ({
    setConsumer(f) {
        self.notifyList = f
    },
    setBrandImage(image) {
        self.brandImage = image.data[0]?.attributes?.headerLogo?.data?.attributes?.url
    },
    select(brand) {
        self.notifyList(brand)
        self.selected = resolveIdentifier(Brand, self, brand?.uuid || brand)
    },

})).views((self) => ({
    options() {
        const {list} = self.brandStore || {};
        return list || []
    },
}))
